export const ACCESS = {
  codes: ['aaa', '777'],
  storageKey: 'onds_unlocked',
  codeStorageKey: 'onds_code',
}

export const PRIVACY = {
  codeStorageKey: 'onds_reveal',
  runCodeStorageKey: 'onds_run',
  mask: '\u2022\u2022\u2022',
}

export const MARKET = {
  ticker: 'ONDS',
  companyName: 'Ondas Holdings',
  sector: 'Autonomous Drones & Defense',
  currency: 'USD',
}

export const PORTFOLIO = {
  taxRateOnGains: 0.25,
  maintenanceMargin: 0.40,
}

export const GOAL = {
  label: 'Exit Target',
  description: 'Reach 10M net as fast as possible. Nothing below the target matters.',
}

export const COMMITTEE = [
  {
    id: 'livermore',
    name: 'Jesse Livermore',
    era: 'The Boy Plunger',
    style: 'Momentum & tape reading',
    tagline: 'Ride the trend, cut losses fast, press winners hard.',
    accent: '#f59e0b',
    initials: 'JL',
  },
  {
    id: 'druckenmiller',
    name: 'Stanley Druckenmiller',
    era: 'Duquesne',
    style: 'Concentrated conviction growth',
    tagline: 'When you are right, size up. Liquidity moves everything.',
    accent: '#a78bfa',
    initials: 'SD',
  },
  {
    id: 'soros',
    name: 'George Soros',
    era: 'Reflexivity',
    style: 'Boom-bust reflexivity',
    tagline: 'It is not whether you are right, but how much when you are.',
    accent: '#f472b6',
    initials: 'GS',
  },
  {
    id: 'tudor',
    name: 'Paul Tudor Jones',
    era: 'Global Macro',
    style: 'Asymmetric macro',
    tagline: 'Defense first, then press clean asymmetric setups hard.',
    accent: '#38bdf8',
    initials: 'PT',
  },
  {
    id: 'lynch',
    name: 'Peter Lynch',
    era: 'Ten-Bagger Hunter',
    style: 'Growth at a reasonable price',
    tagline: 'Buy what you understand and let the winners run.',
    accent: '#22d3ee',
    initials: 'PL',
  },
  {
    id: 'fisher',
    name: 'Philip Fisher',
    era: 'Scuttlebutt Growth',
    style: 'Long-term compounding',
    tagline: 'Find extraordinary growth and hold it for years.',
    accent: '#4ade80',
    initials: 'PF',
  },
  {
    id: 'oneil',
    name: "William O'Neil",
    era: 'CAN SLIM',
    style: 'High-growth momentum',
    tagline: 'Buy market leaders breaking out on volume.',
    accent: '#fbbf24',
    initials: 'WO',
  },
  {
    id: 'miller',
    name: 'Bill Miller',
    era: 'Asymmetric Growth',
    style: 'Concentrated conviction',
    tagline: 'Lowest average cost wins. Volatility is opportunity.',
    accent: '#60a5fa',
    initials: 'BM',
  },
  {
    id: 'buffett',
    name: 'Warren Buffett',
    era: 'Value Anchor',
    style: 'Quality & intrinsic value',
    tagline: 'Be fearful when others are greedy. Price is what you pay.',
    accent: '#34d399',
    initials: 'WB',
  },
  {
    id: 'burry',
    name: 'Michael Burry',
    era: 'Contrarian Risk',
    style: 'Deep contrarian value',
    tagline: 'The crowd is usually wrong at the extremes.',
    accent: '#fb7185',
    initials: 'MB',
  },
]

const FALLBACK_ACCENTS = ['#f59e0b', '#38bdf8', '#a78bfa', '#f472b6', '#34d399', '#fb7185', '#22d3ee', '#c084fc', '#facc15', '#4ade80']

const initialsFromName = (name) =>
  (name || '?')
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

export const resolveCommitteeMember = (item) => {
  const found = COMMITTEE.find((m) => m.id === item.memberId)
  if (found) return found

  const id = item.memberId || ''
  let hash = 0
  for (let i = 0; i < id.length; i += 1) hash = (hash * 31 + id.charCodeAt(i)) | 0
  const accent = FALLBACK_ACCENTS[Math.abs(hash) % FALLBACK_ACCENTS.length]

  return {
    id,
    name: item.name || id,
    era: 'Guest Member',
    style: item.style || '',
    tagline: '',
    accent,
    initials: initialsFromName(item.name || id),
  }
}

export const ACTIONS = {
  BUY_MORE: { key: 'BUY_MORE', label: 'Buy More', tone: 'bull' },
  HOLD: { key: 'HOLD', label: 'Hold', tone: 'neutral' },
  TRIM: { key: 'TRIM', label: 'Trim / Sell Some', tone: 'caution' },
  SELL_ALL: { key: 'SELL_ALL', label: 'Sell All', tone: 'bear' },
  ROTATE: { key: 'ROTATE', label: 'Exit & Rotate', tone: 'bear' },
}

export const NEWS_CATEGORIES = [
  { id: 'macro', label: 'Macro' },
  { id: 'sector', label: 'Drone Sector' },
  { id: 'onds', label: 'ONDS Specific' },
]

export const THEME = {
  bg: '#0a0e17',
  surface: '#111726',
  surfaceRaised: '#161d30',
  border: '#233047',
  textPrimary: '#e6edf7',
  textSecondary: '#8b9bb4',
  accent: '#6366f1',
  bull: '#34d399',
  bear: '#f87171',
  caution: '#fbbf24',
  neutral: '#94a3b8',
}
